export default "__VITE_ASSET__DCrVqVRW__"